import VerticalText from "./VerticalText";
export default VerticalText;
